import React, { useEffect, useState } from 'react';
import EventPageEditor from './EventPageEditor';
import { useParams, useLocation } from 'react-router-dom';
import useRepo from '../../hooks/useRepo'; // Adjust the path as needed
import useApiContext from 'hooks/useApiContext';

function Index() {
  const { eventId } = useParams();
  const location = useLocation();
  const pathname = location.pathname;
  const { eventRepository } = useApiContext();
  const [eventData, setEventData] = useState({
    name: '',
    organizerName: '',
    description: '',
  });

  const { response } = useRepo(
    async () =>
      eventId !== undefined
        ? await eventRepository.getEventById(eventId).then((e) => e)
        : '',
    [pathname]
  );

  useEffect(() => {
    setEventData({
      name: `${response?.name} ${response?.year || 'Vinisud 2024'}`,
      organizerName: `${response?.name} ${response?.year || 'Business France'}`,
      description:
        "L'un des rendez-vous majeurs en Europe pour les vins, spiritueux, bières et cidres",
    });
  }, [response]);

  const handleSave = async (blocks) => {
    console.log('Saving blocks:', blocks);
    // Envoyer à votre API
    try {
      const response = await eventRepository.addPage(eventId, { blocks });
      console.log('Save response:', response);
    } catch (error) {
      console.error('Save error:', error);
    }
  };

  const handlePublish = async (blocks) => {
    console.log('Publishing blocks:', blocks);
    try {
      const response = await eventRepository.publishEventPage(eventId, {
        blocks,
      });
      console.log('Publish response:', response);
    } catch (error) {
      console.error('Publish error:', error);
    }
  };

  return (
    <div className="App">
      <EventPageEditor
        eventId={eventId}
        eventName={eventData.name}
        organizerName={eventData.organizerName}
        onSave={handleSave}
        onPublish={handlePublish}
        apiUrl={process.env.REACT_APP_API_URL || '/api'}
      />
    </div>
  );
}

export default Index;
